export enum ConsumptionPeriods {
    Monthly = 'monthly',
    Quarterly = 'quarterly',
    Yearly = 'yearly',
    BiAnnual = 'biannually'
}
